import React, { useEffect, useState } from 'react';
import FullGameImage from './images/FullGame.png'
import { TeamEventHeader } from './viewComponents/teamEvent'
import { SportsBook } from '../odds/SportsBook';
import { OddsValue } from '../oddsList/OddsValue';
import { SportsBookLinks, getTeamEventUrl, getLineHistoryUrl } from '../../utils/gameUtils';
import { Link } from 'react-router-dom'
export const OddsEventMobileUI = ({ classes, marketFilter, game, league, availableSportsBooks }) => {
    const [showShadow, setShowShadow] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (window.innerWidth < 600) {
            window.addEventListener('scroll', (event) => {
                if (event.target.scrollingElement.scrollTop > 190) {
                    setShowShadow(true);
                } else {
                    setShowShadow(false);
                }
            });
            return () => {
                window.removeEventListener('scroll', () => {})
            }
        }
    }, []);

    return (
        <div>
            <div className={classes.table}>
                <div className={`${classes.mobileHeader} ${showShadow ? classes.shadow : ''}`}>
                    <div className="eventHeader">
                        <div className="track">
                            <div className={`${classes.headerCol} ${classes.fullGameCol}`}>
                                <p>FULL GAME</p>
                                <GetGameLineHistoryURL game={game} league={league} />
                            </div>
                        </div>
                        <div className="track">
                            <div className={classes.headerCol}><TeamEventHeader competitor={game.competitors.away}
                                league={league} /></div>
                        </div>
                        <div className="track">
                            <div className={classes.headerCol}><TeamEventHeader competitor={game.competitors.home}
                                league={league} /></div>
                        </div>
                    </div>
                </div>
                <div className={classes.odds}>
                    {/* <div className="eventOddRow">
                        <div className={`${classes.justifyStart}`}>
                            <div className={classes.mobileSportsBook}>Opener</div>
                        </div>
                        <OddsOpenerValue game={game} marketFilter={marketFilter} />
                    </div> */}
                    {
                        availableSportsBooks.map(function (name) {
                            var markets = game['markets'];

                            if (!markets) return null;

                            const books = markets[marketFilter] || {};

                            const bookData = books[name];

                            if (bookData && bookData.length === 2) {
                                const homeBookData = bookData[0];
                                const awayBookData = bookData[1];

                                return (
                                    <div className="eventOddRow" key={name}>
                                        <div className={classes.justifyStart}>
                                            <div className={classes.mobileSportsBook}>
                                                <a href={SportsBookLinks[name]} target="_blank" rel="noreferrer">
                                                    <SportsBook name={name} />
                                                </a>
                                            </div>
                                        </div>
                                        <div>
                                            <OddsValue width={'96px'} game={game} bookData={homeBookData}
                                                marketFilter={marketFilter} />
                                        </div>
                                        <div className={classes.mobileRightCol}>
                                            <OddsValue width='96px' game={game} bookData={awayBookData}
                                                marketFilter={marketFilter} />
                                        </div>
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })
                    }
                </div>
            </div>
        </div>
    );
}

const GetGameLineHistoryURL = ({ game, league }) => {
    let url = getLineHistoryUrl(league, game);
    return (
        <Link to={url}>
            <img alt="line history button" src={FullGameImage} />
        </Link>
    )
}